/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionMilestone
 */
export interface SessionMilestone {
    /**
     * 
     * @type {string}
     * @memberof SessionMilestone
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionMilestone
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionMilestone
     */
    xpAwarded?: number;
}

/**
 * Check if a given object implements the SessionMilestone interface.
 */
export function instanceOfSessionMilestone(value: object): value is SessionMilestone {
    return true;
}

export function SessionMilestoneFromJSON(json: any): SessionMilestone {
    return SessionMilestoneFromJSONTyped(json, false);
}

export function SessionMilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionMilestone {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
        'xpAwarded': json['xpAwarded'] == null ? undefined : json['xpAwarded'],
    };
}

export function SessionMilestoneToJSON(json: any): SessionMilestone {
    return SessionMilestoneToJSONTyped(json, false);
}

export function SessionMilestoneToJSONTyped(value?: SessionMilestone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'description': value['description'],
        'xpAwarded': value['xpAwarded'],
    };
}

